module.exports = __webpack_public_path__ + "static/media/Mockup_casino_slot.c5f1e146.png";